// src/modulos/Dashboard/dashboards/DefaultDashboard.js
import React, { useMemo } from 'react';
import useFirestore from '../../hooks/useFirestore';

const DefaultDashboard = ({ user }) => {
    // ✅ OTIMIZADO: Queries específicas com where
    const { data: lowStock, loading: stockLoading } = useFirestore('inventory', 'quantity', '<', 10, 100);
    const { data: tickets, loading: ticketsLoading } = useFirestore('helpdesk_tickets', 'status', '==', 'open', 50);

    const stats = useMemo(() => ({
        lowStockCount: lowStock?.length || 0,
        openTicketsCount: tickets?.length || 0
    }), [lowStock, tickets]);

    return 
};

export default DefaultDashboard;